import { createSelector } from 'reselect';
import get from 'lodash/get';
export const getEvent = (state) => state.event.data;
export const getEventTitle = (state) => get(state, 'event.data.title', '');
export const getEventSubTitle = (state) => get(state, 'event.data.sub_heading', '');
export const getTributeOnFullScreen = (state) => get(state, 'event.data.show_in_fullscreen', false);
export const getCommercialLinks = (state) => get(state, 'event.data.commercial_links', []);
export const getObituaryLink = (state) => get(state, 'event.data.partner', []);
export const getVenue = (state) => get(state, 'event.data.venue');
export const getVenueTitle = (state) => get(state, 'event.data.venue.name', '');
export const getVenuePhone = (state) => get(state, 'event.data.venue.phone', '');
export const getVenueWebsite = (state) => get(state, 'event.data.venue.website', '');
export const getVenueEmail = (state) => get(state, 'event.data.venue.email', '');
export const getVenueType = (state) => get(state, 'event.data.venue.type', '');
export const getPreMessage = (state) => get(state, 'event.data.venue.pre_message', '');
export const getPostMessage = (state) => get(state, 'event.data.venue.post_message', '');
export const getStartTime = (state) => get(state, 'event.data.start', '');
export const getEndTime = (state) => get(state, 'event.data.end', '');
export const getFormattedPreMessage = createSelector([
    getPreMessage,
    getEventTitle,
    getEventSubTitle,
    getVenueTitle,
    getVenuePhone,
    getVenueWebsite,
    getVenueEmail,
], (preMessage, eventTitle, eventSubTitle, venueTitle, venuePhone, venueWebsite, venueEmail) => {
    return preMessage
        .replaceAll('{event_title}', eventTitle)
        .replaceAll('{event_subtitle}', eventSubTitle)
        .replaceAll('{venue_title}', venueTitle)
        .replaceAll('{venue_phone}', venuePhone)
        .replaceAll('{venue_website}', venueWebsite)
        .replaceAll('{venue_email}', venueEmail);
});
export const getFormattedPostMessage = createSelector([
    getPostMessage,
    getEventTitle,
    getEventSubTitle,
    getVenueTitle,
    getVenuePhone,
    getVenueWebsite,
    getVenueEmail,
], (postMessage, eventTitle, eventSubTitle, venueTitle, venuePhone, venueWebsite, venueEmail) => {
    return postMessage
        .replaceAll('{event_title}', eventTitle)
        .replaceAll('{event_subtitle}', eventSubTitle)
        .replaceAll('{venue_title}', venueTitle)
        .replaceAll('{venue_phone}', venuePhone)
        .replaceAll('{venue_website}', venueWebsite)
        .replaceAll('{venue_email}', venueEmail);
});
export const getDuration = createSelector([getStartTime, getEndTime], (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    return (end.getTime() - start.getTime()) / 1000;
});
